import { combineReducers } from 'redux'
import { createForms } from 'react-redux-form/immutable'
import { routerReducer as routing } from 'react-router-redux'

import app from 'containers/App/reducer'
import { passwordState } from 'containers/Account/reducer'
import notification from 'components/Notification/reducer'
import auth, { loginState } from 'containers/Auth/reducer'
import { changeSemState } from 'containers/Admin/reducer'
import fee from 'containers/Fees/reducer'
import bulkcode from 'containers/BulkCodes/reducer'
import notepayment, { notePaymentState } from 'containers/NotePayments/reducer'
import payment, { paymentState } from 'containers/Payments/reducer'
import ledger from 'containers/Ledger/reducer'
import student from 'containers/Students/reducer'
import preset, { presetState, presetDetailState } from 'containers/FeesPresets/reducer'
import collection, { collectionState } from 'containers/Reports/Collections/reducer'

export default combineReducers({
  // main reducers
  app,
  auth,
  bulkcode,
  notification,
  fee,
  notepayment,
  payment,
  ledger,
  student,
  preset,
  collection,

  // react-redux-form
  ...createForms({
    loginState,
    passwordState,
    changeSemState,
    paymentState,
    notePaymentState,
    presetState,
    presetDetailState,
    collectionState,
  }),

  // other
  routing,
})



// WEBPACK FOOTER //
// ./src/reducers.js